import { ArrowBendDownLeftIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CornerUpRound = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ArrowBendDownLeftIcon {...rest} size={Sizes[size]} color={fill} />;
};

CornerUpRound.displayName = 'CornerUpRound';
